import * as React from "react";
import { forwardRef } from "react";
const SvgSemicircleUp = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 189, height: 67, viewBox: "0 0 189 67", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { opacity: 0.15, d: "M94.5 67C138.146 67 175.285 39 189 0H156.265C144.453 22 121.228 37 94.5 37C67.7717 37 44.5471 22 32.7346 0H0C13.6144 39 50.8538 67 94.5 67Z", fill: "#F2F9F8" }));
const ForwardRef = forwardRef(SvgSemicircleUp);
export { ForwardRef as ReactComponent };
